export const SERVER_URL = 'https://api.wsd.com.mx/api';
